'use strict';

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _typeof = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (a) {
  return typeof a;
} : function (a) {
  return a && 'function' == typeof Symbol && a.constructor === Symbol && a !== Symbol.prototype ? 'symbol' : typeof a;
},
    _require = require('url'),
    URL = _require.URL,
    centra = require('centra'),
    phin =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(a) {
    var b, c;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!('string' != typeof a && !a.hasOwnProperty('url'))) {
              _context.next = 2;
              break;
            }

            throw new Error('Missing url option from options for request method.');

          case 2:
            b = centra('object' === ('undefined' == typeof a ? 'undefined' : _typeof(a)) ? a.url : a, a.method || 'GET');
            a.headers && b.header(a.headers), a.stream && b.stream(), a.timeout && b.timeout(a.timeout), a.data && b.body(a.data), a.form && b.body(a.form, 'form'), a.compression && b.compress(), 'object' === _typeof(a.core) && Object.keys(a.core).forEach(function (d) {
              b.option(d, a.core[d]);
            });
            _context.next = 6;
            return b.send();

          case 6:
            c = _context.sent;

            if (!(c.headers.hasOwnProperty('location') && a.followRedirects)) {
              _context.next = 14;
              break;
            }

            a.url = new URL(c.headers.location, a.url).toString();
            _context.next = 11;
            return phin(a);

          case 11:
            _context.t0 = _context.sent;
            _context.next = 29;
            break;

          case 14:
            if (!a.stream) {
              _context.next = 18;
              break;
            }

            _context.t1 = (c.stream = c, c);
            _context.next = 28;
            break;

          case 18:
            c.coreRes.body = c.body;

            if (!(a.parse && 'json' === a.parse)) {
              _context.next = 26;
              break;
            }

            _context.next = 22;
            return c.json();

          case 22:
            c.coreRes.body = _context.sent;
            _context.t2 = c.coreRes;
            _context.next = 27;
            break;

          case 26:
            _context.t2 = c.coreRes;

          case 27:
            _context.t1 = _context.t2;

          case 28:
            _context.t0 = _context.t1;

          case 29:
            return _context.abrupt("return", _context.t0);

          case 30:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function phin(_x) {
    return _ref.apply(this, arguments);
  };
}();

phin.promisified = phin, phin.unpromisified = function (a, b) {
  phin(a).then(function (c) {
    b && b(null, c);
  }).catch(function (c) {
    b && b(c, null);
  });
}, phin.defaults = function (a) {
  return (
    /*#__PURE__*/
    function () {
      var _ref2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(b) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return phin(Object.assign(a, 'string' == typeof b ? {
                  url: b
                } : b));

              case 2:
                return _context2.abrupt("return", _context2.sent);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }()
  );
}, module.exports = phin;